<template>
    <ListenerDiscover v-if="isListenerMobile" />
    <Discover v-else />
</template>

<script>
import Discover from './Discover.vue'
import ListenerDiscover from './ListenerDiscover.vue'

export default {
    name: 'DiscoverEntry',
    components: {
        Discover,
        ListenerDiscover
    },
    computed: {
        isListenerMobile() {
            return !this.$store.state.common.isSuperuser
                && typeof window !== 'undefined'
                && window.innerWidth <= 768
        }
    }
}
</script>
